export const EnvironmentUrl = window.Launchpad.ApiBaseUrl;
export const globalProject = window.Launchpad;
export const googleMapsKey = 'AIzaSyBLL3J-PoihogznWieoPuVQnf865UU7uPs';

export const ViewPort = {
	Desktop: 'desktop',
	Tablet: 'tablet',
	Mobile: 'mobile'
};

export const Breakpoints = {
	Desktop: '970',
	Tablet: '750'
};